import React, { useEffect } from "react";
import { TContainerStateProps } from "../../state/TContainerStateProps";
import { CRMTitleSection } from "../../components/CRMTitleSection/CRMTitleSection";
import { CRMSpacer } from "../../components/CRMSpacer/CRMSpacer";
import { CRMAutosaveIndicatorWrap } from "../../components/CRM/CRMAutosaveIndicatorWrap/CRMAutosaveIndicatorWrap";
import { CRMCaseRetentionRows, getRetentionEntries } from "../../components/Complex/CRMCaseRetentionsSection/CRMCaseRetentionsSection";
import { CRMParagraph } from "../../components/Simple/CRMParagraph/CRMParagraph";

const CRMLegalCaseRetentionsContainer = (props: TContainerStateProps): JSX.Element => {

    // The details page payload carries no ledger data, and the retention rows are
    // ledger entries — so this section fetches the ledger itself rather than widening
    // the details codec for three fields.
    useEffect(
        () => props.dispatch({ type: "LEGAL_CASE_GET_LEDGER", payload: null }),
        []
    );

    const entries = props.state.forms.case_ledger_page.case_ledger.children.ledger_entries;
    const hasRetentions = getRetentionEntries(entries).length > 0;

    return (
        <CRMAutosaveIndicatorWrap
            status={props.state.forms.case_ledger_page.case_ledger.status}
        >
            <CRMTitleSection>
                Retentions
            </CRMTitleSection>
            <CRMSpacer size="large" />

            {!hasRetentions &&
                <CRMParagraph>
                    No money is being held back on this case.
                </CRMParagraph>
            }

            {hasRetentions &&
                <CRMCaseRetentionRows
                    entries={entries}
                    onChange={(payload) =>
                        props.dispatch({
                            type: "LEGAL_CASE_UPDATE_LEDGER_ITEM_CHANGE",
                            payload,
                        })
                    }
                />
            }
        </CRMAutosaveIndicatorWrap>
    );
};

export default CRMLegalCaseRetentionsContainer;
